import { createSlice } from "@reduxjs/toolkit";
import { getCustomers, addCustomer, updateCustomer, deleteCustomer } from "./thunk";

export const initialState: {
  customerLists: any[];
  meta: {
    total: number;
    page: number;
    pageSize: number;
  };
  error: any;
  loading: boolean;
} = {
  customerLists: [],
  meta: {
    total: 0,
    page: 1,
    pageSize: 10,
  },
  error: {},
  loading: false,
};

const CustomersSlice = createSlice({
  name: "CustomersSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getCustomers.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getCustomers.fulfilled, (state, action) => {
      state.loading = false;
      if (Array.isArray(action.payload)) {
        state.customerLists = action.payload;
        state.meta = { total: action.payload.length, page: 1, pageSize: 10 };
      } else if (action.payload && Array.isArray(action.payload.data)) {
        state.customerLists = action.payload.data;
        // Guardar metadatos de paginación si existen
        const responseData = action.payload.data;
        
        // Los metadatos pueden estar directamente en payload.data.meta o en payload.meta
        const responseMeta = (action.payload.data as any)?.meta || (action.payload as any)?.meta;
        
        if (responseMeta) {
          state.meta = {
            total: responseMeta.total || 0,
            page: responseMeta.page || 1,
            pageSize: responseMeta.pageSize || responseMeta.limit || 10,
          };
        } else {
          state.meta = { total: responseData.length, page: 1, pageSize: 10 };
        }
      } else {
        state.customerLists = [];
        state.meta = { total: 0, page: 1, pageSize: 10 };
      }
    });
    builder.addCase(getCustomers.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload || { message: "Failed to fetch customers" };
    });
    
    builder.addCase(addCustomer.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(addCustomer.fulfilled, (state, action) => {
      state.loading = false;
      const newCustomer = action.payload.data || action.payload;
      state.customerLists.push(newCustomer);
    });
    builder.addCase(addCustomer.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload || { message: "Failed to add customer" };
    });

    builder.addCase(updateCustomer.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(updateCustomer.fulfilled, (state, action) => {
      state.loading = false;
      const updatedCustomer = action.payload.data || action.payload;
      state.customerLists = state.customerLists.map((customer:any) =>
        customer.id === updatedCustomer.id ? { ...customer, ...updatedCustomer } : customer
      );
    });
    builder.addCase(updateCustomer.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload || { message: "Failed to update customer" };
    });

    builder.addCase(deleteCustomer.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(deleteCustomer.fulfilled, (state, action) => {
      state.loading = false;
      const deletedCustomerId = action.payload; 
      state.customerLists = state.customerLists.filter(
        (customer:any) => customer.id.toString() !== deletedCustomerId.toString()
      );
    });
    builder.addCase(deleteCustomer.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload || { message: "Failed to delete customer" };
    });
  },
});

export default CustomersSlice.reducer;
